<template>
  <div class="wrap">
    <div class="prjList">
      <el-form size="small">
        <el-button type="primary" size="small" @click="publishVersion">
          版本发布
        </el-button>
        <el-button type="primary" plain size="small" @click="importFile">
          导入
        </el-button>
      </el-form>
      <el-table v-loading="loading" :data="tableData" border element-loading-text="数据加载中" height="100%" highlight-current-row style="width:100%">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无消息</p>
        </template>
        <el-table-column type="index" label="序号" width="60px" align="center"> </el-table-column>
        <el-table-column prop="versionName" label="版本号" min-width="70px" show-overflow-tooltip align="center" />
        <el-table-column prop="remark" label="更新内容描述" min-width="140px" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <div class="remark">
              <span v-if="scope.row.status == 0 || scope.row.versionName === latestVersionName"
                style="cursor:pointer;width: 150px">{{ scope.row.remark
                }}</span>
              <el-input v-else v-model="scope.row.remark" style="width: 150px" type="textarea"></el-input>
              <span v-if="scope.row.status == 0 && scope.row.versionName !== latestVersionName"
                style="cursor:pointer;color: #4777e7" class="operate remark"
                @click.stop="changeStatus(scope.row, 1)">编辑</span>
              <span v-if="scope.row.status == 1 && scope.row.versionName !== latestVersionName"
                style="cursor:pointer;" class="operate remark">
                <span @click.stop="changeStatus(scope.row, 0)">取消</span>
                <span style="color: #4777e7;" @click.stop="changeRemark(scope.row)">确定</span>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="publishStatus" label="版本状态" show-overflow-tooltip min-width="80px" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.publishStatus === 0 ? 'gray' : 'green'">{{ scope.row.publishStatus === 0 ? '当前版本' :
              '已发布' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="110px" align="center" />
        <el-table-column prop="publishUserName" label="发布人" min-width="80px" align="center" />
        <el-table-column prop="publishTime" label="发布时间" min-width="110px" align="center" />
        <el-table-column label="操作" min-width="120px" align="center">
          <template slot-scope="scope">
            <span class="btn" @click="downFile(scope.row)">
              导出</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="page">
        <page :page="page" class="el-pagination" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData">
        </page>
      </div> -->
    </div>
    <el-dialog title="
                                                        版本发布" custom-class="profession-dialog"
      :visible.sync="publishVersionDialog" :close-on-click-modal="false" :close-on-press-escape="false" width="600px"
      :before-close="handleCancel">
      <span>
        <div style="padding:20px 0px">版本号：{{ latestVersionName }}</div>
        <div style="padding:20px 0px">更新内容描述</div>
        <div>
          <el-input v-model="publishContent" type="textarea" placeholder="请输入更新内容描述" maxlength="200" show-word-limit>
          </el-input>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button type="primary" size="small" @click="handlePulishConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import service from "@/CommonDP/service/manageVersion-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import page from "@/CommonDP/components/paging";
import { mapState } from "vuex";
export default {
  name: "ManageVersion",
  components: { page },
  data () {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      loading: true,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0
      },
      publishVersionDialog: false,
      publishContent: ''
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    latestVersionName () {
      return this.tableData.at(0)?.versionName || '';
    }
  },

  mounted () {
    this.getTableData();
  },
  methods: {
    handleCancel () {
      this.publishVersionDialog = false;
      this.publishContent = '';
    },
    handlePulishConfirm () {
      const params = {
        "remark": this.publishContent,
        "version": this.tableData.at(0).version
      };
      service.publish(params).then(res => {
        this.handleCancel();
        if (res.result === '0') {
          this.$success('发布成功');
          this.getTableData();
        } else {
          this.$warn(res.message);
        }
      });
    },
    publishVersion () {
      this.publishVersionDialog = true;
    },
    // TODO 后端接口没做
    importFile () { },
    // 导出
    downFile (row) {
      service.exportFile(row.version).then((response) => {
        const fileName = "版本设置导出";
        if ("msSaveOrOpenBlob" in navigator) {
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.excelDisable = true;
          this.excelSelect = false;
        }
      });
    },
    async changeStatus (row, val) {
      row.status = val;
    },
    async changeRemark (row) {
      const params = {
        "remark": row.remark,
        "version": row.version
      };
      await service.updatePublishRemark(params);
      this.getTableData();
    },
    // fetchData (val) {
    //   this.page.pageNo = val;
    //   this.getTableData();
    // },
    // handleSizeChange (val) {
    //   this.page.pageSize = val;
    //   this.page.pageNo = 1;
    //   this.getTableData();
    // },
    async getTableData () {
      this.loading = true;
      // const {
      //   page: { pageNo, pageSize },
      //   enterpriseId,
      // } = this;
      // const params = {
      //   enterpriseId,
      //   pageNum: pageNo,
      //   pageSize,
      // };
      const res = await service.queryPublishVersionList();
      if (res.result === "0") {
        this.tableData = res.data.map(item => {
          item.status = 0;
          return item;
        });
        this.loading = false;
      }
    }

  }
};
</script>

<style lang="scss" scoped>
/deep/.prjDetail {
  height: 500px;
  overflow: auto;
}

.people_class {
  /deep/.el-dialog__body {
    height: 600px;
  }
}

.bottom_left {
  height: 100%;
  overflow: auto;

  .tree_1 {
    font-size: 14px;
  }
}

.notClick {
  cursor: not-allowed;
}

/deep/ .el-tree-node:focus>.el-tree-node__content {
  background: #6d6d6d;
}
</style>
<style lang="stylus" scoped>
.wrap {
  height: 100%;
  box-sizing: border-box;
  padding: var(--big-space);
.green {
  color: #0ABB87;
}
.remark {
  display: flex;
  justify-content: space-between;
  padding:  0 20px;
  align-items: center
}
.operate {
  width : 100px;
}
  .header {
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
    padding: 10px 25px;
    line-height: 25px;
    color: var(--key-color);
    font-weight: 600;
    font-size: 16px;
    background: #fff;
  }

  .prjList {
    height: calc(100%);
    display: flex;
    flex-direction: column;
    background: #fff;

    .btn {
      cursor: pointer;
      color: #858EBD;
      margin-right: 3px;
    }

    .prjList_form {
      padding: 10px 25px;
      border-bottom: 1px solid rgba(211, 217, 232, 0.77);
      margin-bottom: 10px;
    }

    .el-form-item {
      margin-bottom: 0;

      /deep/.el-form-item__content {
        height: 40px !important;
      }
    }

    .el-table {
      margin-top: var(--middle-space);
    }

    .page {
      .el-pagination {
        float: right;
        line-height: 40px;
      }
    }
  }
}
</style>
